module.exports = new __parcel__URL__("machines_community_nominee_2023_level_1.0329d5b1.png").toString();